import { render, staticRenderFns } from "./AdminPeopleSearch.vue?vue&type=template&id=66549824&scoped=true&"
import script from "./AdminPeopleSearch.vue?vue&type=script&lang=js&"
export * from "./AdminPeopleSearch.vue?vue&type=script&lang=js&"
import style0 from "./AdminPeopleSearch.vue?vue&type=style&index=0&id=66549824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66549824",
  null
  
)

export default component.exports